module.exports = __webpack_public_path__ + "fonts/Inter-400-greek-ext24.318d4ba.woff2";